import { useFormContext } from 'react-hook-form';

import { getAiAgeGenerationByAgeId } from '../../../utils/getAiAgeGeneration';
import { LayoutDataType } from '../types';

export const useLayoutFormSelections = () => {
  const form = useFormContext<LayoutDataType>();

  const hairColor = form.watch('hair_color');
  const bodyShape = form.watch('body_shape');
  const age = form.watch('age');
  const ageGeneration = getAiAgeGenerationByAgeId(age);

  return {
    hairColor,
    bodyShape,
    age,
    ageGeneration,
  };
};
